<template>
    <div class="page bgF6F6F6 lineHeight1p375">
        <div class="imageArea" style="height: 226px">
            <img class="block fullSpace" :src="dataItem ? dataItem.coverImg : ''"/>
        </div>
        <div
            class="vipFreeInfoArea"
            v-show="
        dataItem &&
        dataItem.isVip &&
        user &&
        !user.isVipType('super') &&
        !user.isVipType('course_vod')"
            @click="appHelper.redirect('/vip')"
        >

        </div>

        <div class="white_bg generalPagePaddingH paddingV20 marginB12">
            <div class="title font18r bold" style="margin-bottom: 8px">
                {{ dataItem ? dataItem.title : "" }}
            </div>
            <div class="font12r color999 marginB8">
                <label class="textLabel alignCenter marginR8">
                    共{{
                        dataItem && dataItem.bizList ? dataItem.bizList.total : 0
                    }}个系列课程
                </label>
                <label class="textLabel alignCenter marginR8">
                    立省{{ dataItem ? dataItem.discount : 0 }}元
                </label>
            </div>
            <div class="clearfix">
                <div class="floatL">
<!--                    <span class="font10r color333">组合价</span>-->
                    <span class="font10r color333">官方指导价</span>
                    <span class="font12r colorF55050">￥</span>
                    <strong class="font24r colorF55050">
                        {{ dataItem ? dataItem.price : 0 }}
                    </strong>
                    <span class="textDelete grey60 font10r">
            原价￥{{ dataItem ? dataItem.marketPrice : "??" }}
          </span>
                </div>
<!--                <div class="fr font12r color999">-->
<!--                    {{ dataItem ? dataItem.applyCount || 0 : 0 }}人购买-->
<!--                </div>-->
            </div>
        </div>


        <div class="white_bg marginB12">
            <div class="paddingH16 paddingV12">
                <!-- title row -->
                <div class="color333" style="margin-bottom: 18px">
                    <strong class="bold marginR4">专题包课程</strong>
                    <span class="color999 font14r">
                        ({{
                            dataItem && dataItem.bizList ? dataItem.bizList.total : 0
                        }}套课程)
                    </span>
                </div>
                <!-- end title row -->
                <div class="courseList">
                    <div class="courseItem"
                        v-for="courseItem in dataItem && dataItem.bizList ? dataItem.bizList.records : []"
                        :key="courseItem.id"
                        data-click="viewCourse(courseItem)"
                    >
                        <!-- 纵向图文布局 -->
                        <div class="inner flexLayout padding8 bgF9F9F9 roundBorder8 marginB12">
                            <div class="imageArea hiddenOverflow" style="width: 86px; border-radius: 6px">
                                <img class="cover" :src="courseItem.coverImg" style="height: 56px" @click="viewCourse(courseItem)"/>
                            </div>
                            <div class="flexItem paddingL8">
                                <div class="titleArea font14r color333 bold hiddenOverflow"
                                    style="
                    line-height: 1.286em;
                    max-height: 2.572em;
                    margin: 5px 0 7px;
                  " @click="viewCourse(courseItem)">
                                    {{ courseItem.title }}
                                </div>
                                <div class="clearfix">
                                    <div class="priceArea floatL color333">
                                        <span class="font10r">单购价</span>
                                        <span class="font12r">￥</span>
                                        <strong class="font14r">{{ courseItem.price }}</strong>
                                    </div>
<!--                                    <div-->
<!--                                        class="learningArea fr f12 color999"-->
<!--                                        style="padding-top: 4px"-->
<!--                                        v-show="courseItem.liveCount > 0"-->
<!--                                    >-->
<!--                                        共{{ courseItem.liveCount }}节课-->
<!--                                    </div>-->
                                    <div class="learningArea fr f12 color999" style="padding-top: 4px">
                                        <button class="learnButton font12r" v-show="dataItem && dataItem.isPay"
                                             @click="viewCourse(courseItem)">去学习</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!-- end .inner -->
                    </div>
                    <!-- end .courseItem -->

                    <!--                    <div class="font12r grey60 alignCenter" style="padding-bottom: 54px;">-->

                    <!-- disable in 2021-03-15-->
                    <!--                        <router-link to="/learn" style="color: #8994A9;">更多VIP免费在“马上学”</router-link>-->
                    <!--                    </div>-->
                </div>
            </div>
        </div>

        <div class="white_bg" style="margin-bottom: 12px">
            <div class="generalPagePaddingH paddingV12">
                <div class="color333 bold marginB20">详情</div>
                <article class="article"
                         style="padding-bottom: 40px"
                         v-html="dataItem ? dataItem.introduce : ''"
                ></article>
            </div>
        </div>

        <div class="bottomOperationArea" v-show="dataItem && dataItem.showPay && !dataItem.isPay">
            <div class="inner generalPagePaddingH flexLayout">
                <div class="flexItem">
                    <div class="font14r" style="line-height: 1.428em; padding-top: 6px">
                        <strong class="price">
                            ￥<span style="font-size: 171.42%">{{
                                dataItem ? dataItem.price || 0 : 0
                            }}</span>
                        </strong>
                    </div>
                    <div class="font12r color333 bold">组合价</div>
                </div>
                <div style="width: 209px">
                    <button class="button block bookButton white f16" @click="goToBuy">
                        一键购买
                    </button>
                </div>
            </div>
        </div>

        <a class="fixedBackIcon" href="javascript:;" @click="back()">
            <img class="icon" src="icon/back_icon.svg"/>
        </a>
        <a class="fixedShareIcon" href="javascript:;" @click="sharePoster()">
            <img class="icon" src="icon/white_circle_share_icon.svg"/>
        </a>

        <coursePayDialog
            ref="payDialog"
            :onPaySuccess="onPaySuccess"
            type="prepay_combo"
            agreeServiceName="师讯网络专题课购买协议"
            agreeServiceUrl="/help/agreement/topic_agreement"
            @selectAddress="$refs.myAddressDrawer.show();"
        />

        <!--        <obtainCouponDialog ref="obtainCouponDialog"-->
        <!--            :onOk="onOkObtainCouponDialog" :onClose="onCloseObtainCouponDialog"/>-->

        <shareDrawer ref="shareDrawer" :bizType="bizTypeEnum.PACKAGE.code"/>

        <distributeButton orderBizType="COMBO" :id="dataItem ? dataItem.id : ''"
            @sharePoster="sharePoster()"
        />

        <myAddressDrawer ref="myAddressDrawer" @selectAddress="onSelectAddress"/>

        <confirmAgreementBeforeLearnDialog ref="confirmAgreement"
           agreeServiceName="师讯网络专题课购买协议"
           agreeServiceUrl="/help/agreement/topic_agreement"
           @ok="onConfirmAgreement()"
        />

    </div>
    <!-- end .page -->
</template>

<script>
import shixunPagePart from "@/components/shixunApp/shixunPagePart";
import moment from "moment";

// modules
import coursePayDialog from "@comp/vodCourse/coursePayDialog";
import obtainCouponDialog from "@comp/coupon/obtainCouponDialog";
import shareDrawer from "@comp/drawer/shareDrawer";
import distributeButton from "@/components/distribution/distributeButton";
import myAddressDrawer from "@/components/shopping/myAddressDrawer";
import confirmAgreementBeforeLearnDialog from "@comp/confirmAgreementBeforeLearnDialog";

// style
import "@comp/vodCourse/course.scss";

// data
import bizTypeEnum from "@/data/bizTypeEnum";

// api
import browsingApi from "@api/browsing";

// platformApi
import requestManager from "@comp/platformApi/requestManager.js";

// config
import appConfig from "@/appConfig";

// util
import consoleHelper from "@util/consoleHelper";
import objectHelper from "@util/objectHelper";
import userUtil from "@comp/shixunApp/userUtil";
import wechatHelper from "@util/wechatHelper";
import appHelper from "@util/appHelper";
import payApi from "@comp/deal/payApi";
import comboApi from "./comboApi";
import htmlHelper from "@util/htmlHelper";

const config = {
    apiConfig: {
        get: {
            url: "portal/v4/index/combo",
            dataColumnMapping: {
                // userName : 'name'
            },
        },
    },
};

export default {
    name: "topicPackageDetail",
    extends: shixunPagePart,
    components: {
        coursePayDialog,
        obtainCouponDialog,
        shareDrawer,
        distributeButton,
        myAddressDrawer,
        confirmAgreementBeforeLearnDialog
    },
    data() {
        return {
            apiConfig: config.apiConfig,
            tab: {
                active: "详情",
            },
            timer: null,
            countDown: {
                day: 0,
                hour: 0,
                minute: 0,
                second: 0,
            },
            user: null,
            appHelper: appHelper,
            enableDataItem: true,

            bizTypeEnum,
            agreementStatus : false
        };
    },
    methods: {
        /**
         * 检查登录后，可直接访问 this.user
         */
        onLoadDataItem() {
            this.title = this.dataItem.title;

            appHelper.setTitle(this.dataItem.title);

            this.setWechatShare();

            // 支付或线下报名后检查协议同意记录
            if (this.dataItem.isPay)
            {
                comboApi.getAgreementStatus(this.dataItem.id, (status) => {
                    this.agreementStatus = status;
                });
            }

        },
        formatDateYMD: function (timestamp) {
            return moment(timestamp).format("YYYY.MM.DD");
        },
        formatDateMD: function (timestamp) {
            return moment(timestamp).format("MM.DD");
        },
        formatDateSegmentLength(seconds) {
            let second = seconds % 60;
            let minute = (seconds - second) / 60;
            let txt = minute + "分" + second + "秒";
            return txt;
        },
        viewCourse(courseItem) {
            if (!this.agreementStatus)
            {
                this.$refs.confirmAgreement.show();
            }
            else {
                appHelper.redirect("/learn/course/" + courseItem.id);
            }
        },

        goToBuy: function () {
            if (
                moment(this.dataItem.startTime).format("YYYY-MM-DD HH:mm:ss") <=
                moment(Date.parse(new Date())).format("YYYY-MM-DD HH:mm:ss") &&
                moment(this.dataItem.endTime).format("YYYY-MM-DD HH:mm:ss") >=
                moment(Date.parse(new Date())).format("YYYY-MM-DD HH:mm:ss")
            ) {
                this.$refs.payDialog.setProduct({
                    id: this.dataItem ? this.dataItem.id : "",
                    title: this.dataItem ? this.dataItem.title : "",
                    image: this.dataItem ? this.dataItem.coverImg : "",
                    // vodType : urlHelper.getUrlParam('vodType') || '',
                    price: this.dataItem ? this.dataItem.price : "",
                    bizType: bizTypeEnum.PACKAGE.code,
                });
                this.$refs.payDialog.open();
            } else if (
                moment(this.dataItem.startTime).format("YYYY-MM-DD HH:mm:ss") >=
                moment(Date.parse(new Date())).format("YYYY-MM-DD HH:mm:ss")
            ) {
                // console.log("还没开始");
                appHelper.showHint('亲,还没开始噢!。');
            } else {
                appHelper.showHint('亲,已经结束了!。');
            }
        },
        onPaySuccess: function () {
            // this.$refs.obtainCouponDialog.updateDataList({
            //     activityId : this.dataItem.goActivityInfo.id
            // });

            this.$refs.payDialog.hide();

            // reload data
            this.loadDataItem(this.dataItem.id);
        },
        onOkObtainCouponDialog() {
            this.hide();
            this.$parent.reloadDataItem();
        },
        onCloseObtainCouponDialog() {
            this.hide();
            this.$parent.reloadDataItem();
        },
        back: function () {
            appHelper.redirect("/");
        },
        share() {
            appHelper.shareAlert();
        },
        setWechatShare() {
            let wechatShareOptions = {
                title: appHelper.getTitle(), // 分享标题
                desc: htmlHelper.removeTag(this.dataItem.introduce) || appConfig.wechat.defaultDescription, // 分享描述
                link: appHelper.generateShareUrl(
                    "/topicPackage/" +
                    this.dataItem.id +
                    "/promotion/" +
                    this.user.introduceCode
                ),
                imgUrl: this.dataItem ? this.dataItem.coverImg : appHelper.getAppIcon(), // 分享图标
            };

            wechatHelper.setShare(wechatShareOptions);
        },
        recordBrowse(options = {}) {
            const promotionCode = options.promotionCode || "";
            const id = options.id || "";

            let requestOptions = objectHelper.clone(browsingApi.transmitBrow);
            requestOptions.data = {
                id: id,
                bizType: "INDEX_TOPIC",
                promotionCode: promotionCode,
            };
            requestManager.request(requestOptions, (error) => {
                if (error) {
                    consoleHelper.logError(error);
                    return;
                }
            });
        },
        sharePoster() {
            if (typeof this.$refs.shareDrawer === "undefined") {
                this.share();
                return;
            }

            this.$refs.shareDrawer.init({
                id: this.dataItem.id,
            });
        },
        onSelectAddress(data) {

            const me = this;
            payApi.submitCollectInfo({
                bizId : this.dataItem.id,
                bizType : bizTypeEnum.PACKAGE.code,
                payInfo : JSON.stringify(data)
            }, (result) => {
                appHelper.showHint('保存成功');
                me.$refs.payDialog.checkNeedFillInContactInformation();
            });
        },
        onConfirmAgreement() {
            comboApi.submitStatus(this.dataItem.id, () => {
                this.agreementStatus = true;
                this.$refs.confirmAgreement.hide();
            });
        }
    },
    mounted() {
        console.log(this.dataItem);

        const id = this.$route.params.id || "";
        const promotionCode = this.$route.params.promotionCode || "";

        if (promotionCode) {
            this.recordBrowse({
                promotionCode: promotionCode,
                id: id,
            });
        }

        const me = this;

        appHelper.checkLogin(
            function (error, user) {
                // me.user = user;
                me.user = userUtil.createUser(user);
                me.loadDataItem(id);
            },
            {
                promotionCode: promotionCode,
            }
        );

    },
    watch: {
        $route(to, from) {
            // 同页面不同参数需要使用函数加载新数据
            if (to.name === from.name) {
                const id = to.params.id || "";
                this.$route.params.id = id;

                this.dataItem = {};
                this.loadData(id);
                window.scrollTo(0, 0);
            }
            // this.$router.go(0)  // 安卓下会刷新页面，微信下会回到旧地址，苹果下无法跳转
        },
    },
};
</script>

<style lang="scss" scoped>
.textLabel {
    border: solid 1px #f55050;
    color: #f55050;
    background: #fff5f5;
    /*padding: 0px 2px;*/
    padding: 0;
    border-radius: 2px;
    height: 16px;
    line-height: 14px;
    font-size: 10px;
}

.tabComp {
    .header {
        .menu {
            .item {
                position: relative;
                float: left;
                padding: 14px 16px;

                &.active {
                    color: #333;

                    &:before {
                        content: "";
                        display: block;
                        position: absolute;
                        width: 18px;
                        height: 2px;
                        background: #f55050;
                        bottom: 6px;
                        left: 50%;
                        margin-left: -9px;
                    }
                }
            }
        }
    }

    .body {
        .inner {
            padding: 16px 18px;
        }
    }
}

.introduction {
    padding: 10px 0 18px;
}

.introduction .title {
    position: relative;
    padding-left: 12px;
}

.introduction .title:before {
    display: block;
    content: "";
    position: absolute;
    width: 2px;
    height: 14px;
    background: #f55050;
    top: 5px;
    left: 0;
}

.introduction p {
    margin-bottom: 12px;
}

.timeCountDown .textLabel {
    background-color: #ffba43;
    border: none;
    color: white;
    padding: 0 4px;
}

.detailContent {
    display: block;
    overflow: hidden;

    img {
        max-width: 100%;
    }
}

.sectionListContent {
    .sectionList {
        margin-top: 0.1rem;

        .flex-item {
            flex: 1;
        }

        .item {
            position: relative;
            padding: 10px 12px;
            background-color: #f9f9f9;
            border-radius: 4px;
            margin-bottom: 8px;

            &:last-child {
                border-bottom: 0;
            }

            .title {
                /*width: 14rem;*/
                margin-bottom: 0.3rem;
                overflow: hidden;
                line-height: 1.5em;
                max-height: 3em;
                padding-right: 10px;
            }

            &.active .title {
                color: #0097fe;
                font-weight: 500;
            }

            .time {
                color: #888;
            }

            .tryBtn span {
                display: inline-block;
                padding: 5px 8px;
                color: #fff;
                border-radius: 4px;
                background-color: #1090ff;
            }
        }
    }
}

.bottomOperationArea {
    height: 82px;
    width: 100%;
    box-sizing: border-box;

    .inner {
        position: fixed;
        height: 82px;
        width: 100%;
        left: 0;
        bottom: 0;
        background-color: white;
        box-sizing: border-box;
        padding-top: 3px;
    }

    .label {
        vertical-align: top;
    }
}

.bookButton {
    width: 209px;
    height: 42px;
    // background: linear-gradient(169deg, #FF6434 0%, #FF3452 100%);

    background: linear-gradient(90deg, #ffa115 0%, #ffbf60 100%);
    border-radius: 21px;
}

.vipFreeInfoArea {
    height: 61px;
    background-image: url("data:image/svg+xml;base64,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");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-size: cover;
}
.learnButton {
    background: #F4950E;
    color: white;
    width: 67px;
    height: 24px;
    line-height: 24px;
    border-radius: 10px;
    padding:0;
    border : 0 none;
}
</style>
